import { createFileRoute } from '@tanstack/react-router';

import { OrgPlanPage } from '@/features/billing/plan-page';

export const Route = createFileRoute('/_app/supplier/$orgId/billing')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  return <OrgPlanPage orgId={orgId} />;
}
